import { PessoaAuditoriaAcesso } from '../pessoa-auditoria-acesso.model';
import { Component, OnInit, ViewChild } from '@angular/core';
import { PessoaAuditoriaAcessoService } from '../pessoa-auditoria-acesso.service';
import { ConsultaPaginada, MensagemService, Restricao, RestricaoOperador, RestricaoPadrao, Restricoes } from 'maestro-ng';
import { SelectItem } from 'primeng/api';
import { SelectItemService } from '../../services/select-item.service';
import { VirtualScroller } from 'primeng/virtualscroller';

@Component({
  selector: 'app-auditoria-consulta-processo-lista',
  templateUrl: './pessoa-auditoria-acesso-lista.component.html',
  styleUrls: ['./pessoa-auditoria-acesso-lista.component.css'],
})
export class PessoaAuditoriaAcessoListaComponent implements OnInit {
  public componentesAuditoriaPessoaItens: SelectItem[];
  public quantidadeRegistros = 20;
  public pessoasAuditoria: PessoaAuditoriaAcesso[];
  public carregandoPessoasAuditoria: boolean;
  public restricoes: Restricoes;
  public error = false;
  public graphql = null;

  @ViewChild('vsPessoasAuditoria')
  public vs: VirtualScroller;

  constructor(
    private service: PessoaAuditoriaAcessoService,
    private selectItemService: SelectItemService,
    private mensagemService: MensagemService
  ) {
    this.restricoes = new Restricoes([
      new Restricao<string>({ atributo: 'id', operador: RestricaoOperador.EQUALS }),
      new Restricao<string>({ atributo: 'pessoa.nome', operador: RestricaoOperador.START_WITH }),
      new Restricao<number>({ atributo: 'usuario.nome', operador: RestricaoOperador.START_WITH }),
      new Restricao<Date>({ atributo: 'dataAcesso', operador: RestricaoOperador.LE, padrao: RestricaoPadrao.DATE }),
      new Restricao<string>({ atributo: 'componente', operador: RestricaoOperador.EQUALS }),
    ]);
  }

  ngOnInit(): void {
    this.componentesAuditoriaPessoaItens = this.selectItemService.getPessoaAuditoriaAcessoComponenteItens();
  }

  parseJson(jsonString: string): any {
    try {
      let parsedJson = jsonString;
      if (parsedJson.includes('\\"')) {
        parsedJson = parsedJson.replace(/\\"/g, '"');
        parsedJson = parsedJson.slice(1, -1);
      }
      if (parsedJson.includes('\\')) {
        parsedJson = parsedJson.replace(/\\/g, '');
      }
      return JSON.parse(parsedJson);
    } catch (error) {
      console.error('Erro ao converter a string JSON:', error);
      return null;
    }
  }

  public onEnterPesquisar(event): void {
    if (event.keyCode === 13) {
      this.pesquisar();
    }
  }

  pesquisar() {
    const primeiroCarregamento = this.pessoasAuditoria === undefined;
    this.pessoasAuditoria = Array.from({ length: this.quantidadeRegistros * 2 });
    if (this.vs !== undefined) {
      this.vs.scrollToIndex(0);
    }
    if (!primeiroCarregamento) {
      this.onLazyLoad(0);
    }
  }

  public onLazyLoad(firstResult: number): void {
    this.carregarPessoas(firstResult);
  }

  private carregarPessoas(firstResult?: number): void {
    this.carregandoPessoasAuditoria = true;
    this.error = false;

    const consulta = new ConsultaPaginada();
    consulta.inicio = firstResult || 0;
    consulta.limite = this.quantidadeRegistros;
    consulta.restricoes = this.restricoes.getAtivas();
    consulta.contabilizar = false;

    this.service
      .recuperarPaginado(consulta)
      .then((resultado) => {
        const carregados = this.pessoasAuditoria.filter((item) => item !== undefined);

        if (resultado.entidades.length === 0) {
          this.pessoasAuditoria = carregados;
        } else if (resultado.entidades.length < this.quantidadeRegistros) {
          this.pessoasAuditoria = carregados.concat(resultado.entidades);
        } else {
          this.pessoasAuditoria = carregados
            .concat(resultado.entidades)
            .concat(Array.from({ length: this.quantidadeRegistros * 2 }));
        }

        this.carregandoPessoasAuditoria = false;
      })
      .catch((response) => {
        this.carregandoPessoasAuditoria = false;
        this.error = true;
        this.mensagemService.addErro('Erro ao carregar os dados da pesquisa!', response.error);
      });
  }

  public limpar() {
    this.pessoasAuditoria = undefined;
    this.error = false;
    this.restricoes.limpar();
  }

  mostrarGraphQL(data) {
    this.graphql = data;
  }

  public fecharGraphQL() {
    this.graphql = null;
  }
}
